import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, filter, first, of, switchMap } from 'rxjs';
import { UserDetails } from '@bn/api-interfaces';
import { UserDetailsStateService } from '@bn/auth/services';

@Injectable({ providedIn: 'root' })
export class EmailNotVerifiedPageGuard implements CanActivate {
  private readonly userDetailsService = inject(UserDetailsStateService);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.userDetailsService.getUserDetails().pipe(
      filter((userDetailsData: UserDetails | null) => userDetailsData !== null),
      switchMap((userDetailsData: UserDetails | null) => {
        if (userDetailsData?.EmailVerified) {
          this.router.navigate(['/']);

          return of(false);
        }

        return of(true);
      }),
      first(),
    );
  }
}
